import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { clearStorage, readLoginPath, readUserCode, writeLoginPath, writeUserCode, readUserName, readSiderWidth } from '../../../utils/storage';
import { publishLogout, publishSliderWidth } from '../../../utils/ps';
import { DoLogout } from "../../../services/plat/UserService";
import HeaderMenu from './menu';

import clsName from './index.module.scss'
import { actionCreator } from '../../data/store';
import store from '../../../store';


const Header = ()=> {

  const [collapsed, setCollapsed] = useState(false)

  const handleCollapsed = ()=> {
    setCollapsed(!collapsed)
    publishSliderWidth(collapsed ? readSiderWidth() + 'px' : '0px')
  }

  const handleChange = async()=> {
    await DoLogout({})

    const action = actionCreator.PageStateAction({});
    store.dispatch(action)
    
    const userCode = readUserCode();
    const loginPath = readLoginPath();

    clearStorage()
    writeLoginPath(loginPath)
    writeUserCode(userCode);
    
    publishLogout()
  }

  return (
    <div className={clsName.header}>
      <div className={clsName.west}>
        <div className={clsName.brand}>科研数据小助手</div>
        <span onClick={handleCollapsed} className={clsName.collapsed}>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
        </span>
      </div>
      <HeaderMenu/>
      <div className={clsName.online}>
        <Dropdown menu={{ onClick: handleChange, items: [{label: '退出登录', key: 'logout'}] }} overlayClassName={clsName.overlay} trigger={['click']} arrow>
          <button className={clsName.trigger}>{readUserName()}</button>
        </Dropdown>
      </div>
    </div>
  )
}

export default Header